<div class="relative h-full rounded-3 bg-grey-50 px-lg py-xl text-center">
  @if (icon) {
    <div
      class="absolute flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-1"
      style="top: -1.4rem; left: calc(50% - 1.375rem)"
    >
      @if (!!icon) {
        <fa-icon [icon]="icon!" class="text-gold-500"></fa-icon>
      }
    </div>
  }
  <div class="flex h-[3rem] items-center justify-center heading-3xl">
    <ng-content select="[content=value]"></ng-content>
  </div>
  @if (title) {
    <div class="mt-2xs plot-md">{{ title }}</div>
  }
  @if (description) {
    <div class="mt-2xs text-sm">{{ description }}</div>
  }
</div>
